module.exports = "<div *ngIf=\"text\" class=\"DAG-dora-grid-title\" [innerHTML]=\"text\">\n</div>\n"